import { isSSR } from 'app/packages/components';

import { CLEAR_GLOBAL_CONFIGS_EMIT } from '../../bin/constants';
import { createCache } from './$global';

// ---

type ConfigCache<T> = {
  DATA?: T;
};

export default function createClientConfig<T>(name: string) {
  const $cache = createCache('createClientConfig');

  if (!isSSR) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    process.on(CLEAR_GLOBAL_CONFIGS_EMIT, () => {
      localStorage.removeItem(name);
    });
  }

  function setConfig(templates: T) {
    const config: ConfigCache<T> = $cache(name);
    config.DATA = templates;
    localStorage.setItem(name, JSON.stringify(templates));
  }

  function getConfig(): T | null {
    const config: ConfigCache<T> = $cache(name);

    if (config.DATA) {
      return config.DATA;
    }

    const configFromStorage = localStorage.getItem(name);

    if (configFromStorage) {
      const parsedConfig = JSON.parse(configFromStorage);
      config.DATA = parsedConfig;
      return parsedConfig;
    }

    return null;
  }

  return {
    setConfig,
    getConfig,
  };
}
